import { Injectable, signal, inject } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RouteLoadingService {
  readonly loading = signal(false);

  constructor() {
    const router = inject(Router);
    router.events.pipe(filter(e =>
      e instanceof NavigationStart ||
      e instanceof NavigationEnd ||
      e instanceof NavigationCancel ||
      e instanceof NavigationError
    )).subscribe(e => {
      this.loading.set(e instanceof NavigationStart);
    });
  }
}
